import React from "react";

const TermsOfService = () => (
  <main className="section-padding max-w-3xl mx-auto">
    <h1 className="text-3xl font-serif font-bold mb-6 text-gold">Terms of Service</h1>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
      <p>By accessing or using IMS Limo & Chauffeur Service, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree, please do not use our services.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">2. Services</h2>
      <p>IMS Limo & Chauffeur Service provides luxury ground transportation. All bookings are subject to availability and confirmation. We reserve the right to refuse service to anyone for any reason at any time.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">3. User Responsibilities</h2>
      <p>You agree to provide accurate information and to use our services only for lawful purposes. You are responsible for maintaining the confidentiality of your booking details and for all activities that occur under your account.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">4. Payment & Cancellations</h2>
      <p>All payments must be made in full prior to service. Cancellations must be made at least 24 hours in advance to avoid charges. No-shows or late cancellations may incur a full fare charge.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">5. Limitation of Liability</h2>
      <p>IMS Limo & Chauffeur Service is not liable for any indirect, incidental, or consequential damages arising from the use of our services. Our maximum liability is limited to the amount paid for the service.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">6. Changes to Terms</h2>
      <p>We reserve the right to update these Terms at any time. Continued use of our services constitutes acceptance of the revised Terms.</p>
    </section>
    <section>
      <h2 className="text-xl font-semibold mb-2">7. Contact</h2>
      <p>If you have any questions about these Terms, please contact us at <a href="mailto:info@imslimoandchaufferservice.com" className="text-gold underline">info@imslimoandchaufferservice.com</a>.</p>
    </section>
  </main>
);

export default TermsOfService;
